<div class="heading"><h2 mat-dialog-title>{{ data.title }}</h2></div>
<button mat-icon-button mat-dialog-close class="close-button">
  <mat-icon>close</mat-icon>
</button>
<mat-dialog-content>
  <div class="message">{{ data.message }}</div>
</mat-dialog-content>
